<template>
  <div>
    <el-dialog
      title=""
      :visible.sync="visible"
      width="50%"
      append-to-body
      top="15vh"
    >
      <div class="main__container">
        <!-- <img
          class="close"
          src="./img/delete.png"
          alt=""
          @click.stop="handlerClose"
        /> -->
        <div class="center-title" v-if="showTitle">{{ title }}</div>
        <div class="left-back" v-if="showBack" @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          返回
        </div>
        <div class="wrapper2 ml-6">
          <!-- <img src="./img/dialog-bg.png" class="bg-img" alt="" /> -->
          <div class="content">
            <div style="width: 100%" class="mt-10">
              <el-input v-model="keyUser" placeholder="搜索用户">
                <div slot="suffix">
                  <div
                    :class="{
                      flex: true,
                      'justify-center': true,
                      'items-center': true,
                      'cursor-pointer': true,
                    }"
                    style="height: 42px; width: 50px"
                  >
                    <img
                      @click="onSearchUser"
                      style="width: 20px; height: 20px"
                      src="./img/search.png"
                      alt=""
                    />
                  </div>
                </div>
              </el-input>
              <div class="list__container">
                <el-table
                  :data="filterUserList"
                  style="width: 100%"
                  class-name="table-name"
                  border
                  :max-height="420"
                  @row-click="onCheckoutItemOfUser"
                >
                  <el-table-column prop="name" label="姓名" width="100">
                  </el-table-column>
                  <el-table-column prop="gender" label="性别" width="100">
                  </el-table-column>
                  <el-table-column prop="age" label="年龄" width="100">
                  </el-table-column>
                  <el-table-column prop="address" label="楼号">
                  </el-table-column>
                  <el-table-column prop="house_number" label="档案标签">
                    <template slot-scope="{ row }">
                      <div v-html="formatRiskLevel(row.riskLevel)"></div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="wrapper3 ml-6" v-if="archivesDetail.archive.sn">
          <ArchivesCard :sn="checkUsers.sn" :detail="archivesDetail" />
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ArchivesCard from "./ArchivesCard.vue";
import DialogArchivesCard from "./DialogArchivesCard.vue";
export default {
  data() {
    return {
      keyUser: "",
      filterUserList: [],
      checkUsers: [],
      archivesDetail: {
        archive: {
          sn: null,
        },
      },
      visibleArchives: false,
    };
  },

  props: {
    show: Boolean,
    tableData: {
      type: Array,
      default: () => [],
    },
    showBack: Boolean,
    showTitle: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    ArchivesCard,
    DialogArchivesCard,
  },
  computed: {
    ...mapGetters(["globalData", "token"]),

    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
  },
  watch: {
    show(n) {
      if (n) {
        this.filterUserList = [...this.tableData];
        (this.checkUsers = []),
          (this.archivesDetail = {
            archive: {
              sn: null,
            },
          });
        this.keyUser = "";
      }
    },
  },
  methods: {
    handleBack() {
      this.visible = false;
      this.$emit("back");
    },
    formatRiskLevel(level = 0) {
      let map = new Map([
        [0, `<span style="color:#34C724;">基本健康人群</span>`],
        [1, `<span style="color:#34C724;">基本健康人群</span>`],
        [2, `<span style="color:#FF8800;">专项关爱人群</span>`],
        [3, `<span style="color:#F54A45;">重点关爱人群</span>`],
      ]);
      return map.get(level);
    },
    handlerClose() {
      this.visible = false;
    },
    onCheckoutItemOfUser(row) {
      this.checkUsers = row;
      this.$emit("onSelect", row);
      // this.getArchivesDetail();
      return;
    },

    onSearchUser() {
      if (!this.keyUser) {
        this.filterUserList = this.tableData;
        return;
      }
      this.filterUserList = this.tableData.filter((v) => {
        v.name.includes(this.keyUser);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.main__container {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
}
.wrapper1,
.wrapper2,
.wrapper3 {
  position: relative;
}

.wrapper2 {
  width: 100%;
  // height: 620px;
}
.wrapper3 {
  width: 50%;
}
.close {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 30px;
  top: 30px;
  z-index: 11111;
  cursor: pointer;
}
.center-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 20px;
  z-index: 11111;
  cursor: pointer;
  color: #333;
  font-weight: bold;
  font-size: 24px;
}
.left-back {
  display: flex;
  align-items: center;
  position: absolute;
  left: 60px;
  top: 0;
  z-index: 11111;
  cursor: pointer;
  color: #333;
  font-weight: bold;
  font-size: 20px;
}
.bg-img {
  position: absolute;
  height: 100%;
  width: 100%;
}
.content {
  position: relative;
  z-index: 2;
  color: #333;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 50px;
  font-weight: bold;
  font-size: 20px;
  width: 100%;
}
.list__container {
  margin-top: 30px;
  height: 370px;
  overflow: scroll;
  .item {
    width: 100%;
    height: 39px;
    background: linear-gradient(90deg, #161f4e 0%, rgba(4, 24, 40, 0.28) 100%);
    //   opacity: 0.28;

    font-size: 16px;
    color: #01b3e6;
    font-weight: 500;
  }
  .item:hover {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
  .active {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
}
// .table-name {
//   color: #333;
// }
// ::v-deep {
//   .el-dialog {
//     // 取消阴影和背景色
//     background: rgba(0, 0, 0, 0);

//     -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

//     box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
//   }
//   .el-input__inner {
//     height: 42px;
//     border: 1px solid #077fd4;
//     border-radius: 8px;
//     background: none;
//     color: #01b3e6;
//   }
//   .el-dialog__headerbtn {
//     top: 78px;
//     right: 100px;
//     z-index: 122;
//     font-size: 30px;
//     color: #fff;
//     font-size: bold;
//   }
//   .el-table,
//   .el-table__body {
//     background: transparent !important;
//     color: #fff;
//   }
//   .el-table th {
//     background-color: transparent !important;
//   }
//   .el-table tr {
//     background-color: transparent !important;
//   }
//   .el-table__body tr.hover-row > td {
//     background-color: #a5ccf2 !important;
//   }
//   .el-table tbody tr:hover > td {
//     background-color: #17468d !important //修改成自己想要的颜色即可
// ;
//   }
// }
</style>
